// extracted by mini-css-extract-plugin
module.exports = {"tableImage":"style__tableImage__97oo2"};